import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { DomainList } from "./DomainList";

// Settings → Members: guest self-signup switch and cap
export const GuestSignupCard = () => {
  const [s, setS] = useState(null);
  const [max, setMax] = useState(20);  useEffect(() => { api.get("/admin/guest-signup").then((r) => { setS(r.data); setMax(r.data.max_active); }); }, []);
  const save = async (body, ok) => {
    try { const { data } = await api.put("/admin/guest-signup", body); setS(data); setMax(data.max_active); toast.success(ok); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!s) return null;
  return (
    <section className="settings-card mb-5" data-testid="guest-signup-card">
      <div className="flex items-center gap-3">
        <h2 className="text-base font-semibold text-neutral-900 mr-auto">Guest sign-up</h2>
        <span className="text-sm text-neutral-600" data-testid="guest-signup-state">{s.enabled ? "On" : "Off"}</span>
        <Switch checked={s.enabled} onCheckedChange={(v) => save({ enabled: v }, v ? "Guest sign-up is on" : "Guest sign-up is off")} data-testid="guest-signup-switch" />
      </div>
      <p className="text-sm text-neutral-500 mt-1" data-testid="guest-signup-usage">
        When on, anyone can pick a username, confirm their email with a code and view Guest albums for 7 days. {s.active} of {s.max_active} guest spots in use.
      </p>
      <div className="flex items-center gap-3 mt-3">
        <span className="text-sm text-neutral-700 mr-auto">Hold suspicious sign-ups for my approval</span>
        <Switch checked={!!s.hold_suspicious} onCheckedChange={(v) => save({ hold_suspicious: v }, v ? "Suspicious sign-ups will wait for you" : "Suspicious sign-ups get in (throttled)")} data-testid="guest-hold-switch" />
      </div>
      <form className="flex items-center gap-2 mt-3" onSubmit={(e) => { e.preventDefault(); save({ max_active: Number(max) }, "Limit saved"); }}>
        <span className="text-sm text-neutral-700">Max active guests</span>
        <input type="number" min={1} max={500} className="login-input !mb-0 !py-1.5 !w-24" value={max} onChange={(e) => setMax(e.target.value)} data-testid="guest-max-input" />
        <button className="btn-outline !py-1.5 !px-3 text-xs" data-testid="guest-max-save">Save</button>
      </form>
      <DomainList label="Trusted domains" hint="Never flagged on domain grounds (family domains count as lower risk automatically)." value={s.trusted_domains || []}
        suggestions={s.suggested_domains || []} onSave={(v) => save({ trusted_domains: v }, "Trusted domains saved")} testid="trusted-domains" />
      <DomainList label="Blocked domains" hint="Guest sign-ups with these email domains are refused." value={s.blocked_domains || []}
        onSave={(v) => save({ blocked_domains: v }, "Blocked domains saved")} testid="blocked-domains" />
    </section>
  );
};
